var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    enableBackground: "new 0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M17.285,18.705c-0.497,0-0.9,0.403-0.9,0.9v1.959c0,0.399-0.323,0.724-0.722,0.724H6.609 c-0.398,0-0.723-0.324-0.723-0.724V4.436c0-0.399,0.324-0.725,0.723-0.725h9.054c0.398,0,0.722,0.325,0.722,0.725v2.189 c0,0.497,0.403,0.899,0.9,0.899s0.9-0.402,0.9-0.899V4.436c0-1.392-1.132-2.524-2.522-2.524H6.609 c-1.392,0-2.523,1.133-2.523,2.524v17.129c0,1.392,1.132,2.524,2.523,2.524h9.054c1.391,0,2.522-1.133,2.522-2.524v-1.959 C18.186,19.108,17.782,18.705,17.285,18.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M23.024,12.363l-3.603-3.601c-0.35-0.351-0.921-0.352-1.272,0s-0.351,0.922,0.001,1.273l2.064,2.063h-8.032 c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.9,0.9,0.9h8.032l-2.065,2.064c-0.352,0.352-0.352,0.922,0,1.273 c0.176,0.176,0.406,0.264,0.637,0.264s0.461-0.088,0.637-0.264l3.603-3.602c0.168-0.169,0.264-0.398,0.264-0.637 C23.289,12.761,23.193,12.532,23.024,12.363z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExit);
export default __webpack_public_path__ + "static/media/icon-exit.fc274faa.svg";
export { ForwardRef as ReactComponent };